import { API, graphqlOperation } from "aws-amplify";
import { configurePlusAppsync, configureGenericAppSync } from 'src/context/AuthContextUtility';



export const getDataFromMetaByAppId = async (appId) => {
    let metaData = null;
    
    let qry = `query MyQuery {
        getAbcAppMetadata(app_id: "${appId}")
    }`;
    
    const onSuccess = (result) => {
        metaData = result.data.getAbcAppMetadata;
        metaData = JSON.parse(metaData);
    };
    
    const onFailure = (error) => {
        console.error("Error fetching metadata:", error);
    };
    
    await executeQuery(qry, onSuccess, onFailure);
    return metaData;
}




export const executeQuery = async (mQry, onSuccess, onFailure, maxRetries = 3, retryDelay = 1000) => {
  let attempts = 0;

  const executeWithRetry = async () => {
    try {
      attempts++;
      await configurePlusAppsync()

      const result = await API.graphql(graphqlOperation(mQry));

      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      // If we haven't reached max retries, try again
      if (attempts < maxRetries) {
        const delay = retryDelay * Math.pow(2, attempts - 1); // Exponential backoff

        await new Promise(resolve => setTimeout(resolve, delay));
        return executeWithRetry(); // Recursive retry
      }

      // If we've exhausted all retries, call onFailure
      if (onFailure) {
        onFailure(error);
      }
    }
  };

  try {
    await executeWithRetry();
  } finally {
    await configureGenericAppSync();
  }
};